import { render, staticRenderFns } from "./PrismaCovid2.vue?vue&type=template&id=75ef8140&scoped=true&"
import script from "./PrismaCovid2.vue?vue&type=script&lang=js&"
export * from "./PrismaCovid2.vue?vue&type=script&lang=js&"
import style0 from "./PrismaCovid2.vue?vue&type=style&index=0&id=75ef8140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ef8140",
  null
  
)

export default component.exports